// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#scitani-2021-root{width:100%;min-height:400px;display:flex;flex-direction:column;justify-content:center;align-items:center;align-content:center;padding:30px}\n", ""]);
// Exports
module.exports = exports;
